import { ContainsByPipe } from './../../../pipe/contains-by.pipe';
import { OrderByPipe } from './../../../pipe/order-by.pipe';
import { Component, EventEmitter, Input, OnInit, Output, Renderer2 } from '@angular/core';
import { ModalRef } from '../modal/modal-ref';
import { Router } from '@angular/router';

@Component({
    selector: 'app-list-tile',
    templateUrl: './list-tile.component.html',
    styleUrls: ['./list-tile.component.css'],
    standalone: false
})
export class ListTileComponent implements OnInit {
  @Input() title:string;
  @Input() titleType:'detail'|'simple'|'complex' = 'simple';
  @Input() id:string = "";
  @Input() list:any[];
  @Input() placeholder:string;
  @Input() orders:string[] = [];
  @Input() filterProperties:string[] = []; //enables search
  @Input() isInsideModalDlg:boolean = false;
  @Input() isLoading:boolean = false;
  @Input() viewLink:string;
  @Input() viewLinkDescription: string;
  @Input() contentHeight: string = "calc(100% - 48px)";
  @Output() itemsEvent = new EventEmitter<any[]>();
  
  showSearch:boolean = false;
  query:string = "";
  items:any[];
  viewLinkClass:string = "";

  constructor(private orderBy: OrderByPipe,
              private containsBy: ContainsByPipe,
              private renderer: Renderer2,
              public modalRef?: ModalRef,
              private router?: Router,)
               { }

  ngOnInit(): void {
    setTimeout(() => {
      if(this.orders.length > 0){
        this.list.sort(this.sortByMultipleFields(this.orders));
      }
      this.itemsEvent.emit(this.list);
      if(this.isInsideModalDlg){
        setTimeout(() => {
          if(this.filterProperties.length > 0){
            this.renderer.selectRootElement('#' + this.id + '-list-tile-search-btn', true).focus();
          }else{
            this.renderer.selectRootElement('#' + this.id + '-list-tile-close-btn', true).focus();
          }
        }, 0);
      }
    }, 0);
  }

  filterList(): void {
    let displayList:any[] = this.list;

    if(this.filterProperties.length > 0 && this.query.trim().length > 0){
      displayList = this.containsBy.transform(displayList, this.filterProperties, this.query);
    }

    this.itemsEvent.emit(displayList);
    this.items = displayList;
  }

  toggleSearchField(): void {
    this.showSearch = !this.showSearch;
  }

  goToViewLink(): void {
    if(this.router){
      this.router.navigate([this.viewLink]);
    }
  }

  onKeyClose(event: KeyboardEvent):void {
    if(event.key === "Escape"){
      this.modalRef.close();
    }
  }

  close(): void {
    this.modalRef.close();
  }

  sortByMultipleFields(orders:string[]): any {
    return function (a, b) {
      return orders
          .map(function (order) {
              var dir = 1;
              //descending order
              if (order[0] === '-') {
                 dir = -1;
                 order = order.substring(1);
              }
              //case insensitive comparison
              if(typeof a[order] === 'string'){
                if (a[order].toLowerCase() > b[order].toLowerCase()) return dir;
                if (a[order].toLowerCase() < b[order].toLowerCase()) return -(dir);
              }else {
                if (a[order] > b[order]) return dir;
                if (a[order] < b[order]) return -(dir);
              }
              
              return 0;
          })
          .reduce(function (p,n) {
              return p ? p : n;
          }, 0);
  };
  }
}
